import { useState } from "react";
import { Collapse } from "@chakra-ui/react";
import { useAuth } from "@/store/auth";
import { getHasActiveSubscription } from "@/store/auth/selectors";
import { Box, Button, Input, Text } from "@/ui";
import { t } from "@/utils";
import { usePremiumScreen } from "@/modules/app/PremiumScreen";
import NavigationBar from "@/components/NavigationBar";
import ListField from "@/components/ListField";

export default function Watermark({
  Progress,
  previous,
  cameraSettings,
  updateSettings
}: CSTypes.CameraSettingsStepProps) {
  const { name, settings } = cameraSettings;
  const { overlayCustomTextEnabled, overlayCustomText, overlayLogoEnabled, overlayTimeEnabled } = settings;

  const { displayBannerForFreeUser } = usePremiumScreen();
  const isPremium = useAuth(getHasActiveSubscription);

  const [fields, setFields] = useState({
    logoEnabled: isPremium ? !!overlayLogoEnabled : true,
    timeEnabled: !!overlayTimeEnabled,
    customTextEnabled: !!overlayCustomTextEnabled
  });

  const [customText, setCustomText] = useState(overlayCustomText || name.slice(0, 30));

  const save = () => {
    updateSettings({
      settings: {
        overlayCustomTextEnabled: fields.customTextEnabled,
        overlayCustomText: customText,
        overlayLogoEnabled: fields.logoEnabled,
        overlayTimeEnabled: fields.timeEnabled
      }
    });
  };

  const handleToggle = (field: keyof typeof fields) => {
    const isEnabled = fields[field];
    if (field !== "logoEnabled" && isEnabled) {
      setFields({ ...fields, [field]: false });
    } else
      displayBannerForFreeUser("watermark").elseRun(() => {
        setFields({
          ...fields,
          [field]: !fields[field]
        });
      });
  };

  const onBack = () => {
    previous();
  };

  return (
    <Box>
      {Progress && <Progress />}
      <NavigationBar title={t("watermark")} onBack={onBack} props={{ mb: "8" }}>
        <Button variant="filledFixedSmall" pos="absolute" right="0" top="2" onClick={save}>
          {t("buttons.save")}
        </Button>
      </NavigationBar>

      <ListField
        iconFill="primary"
        props={{ mb: "16" }}
        label={t("logo")}
        switch={{
          isChecked: fields.logoEnabled,
          onChange: () => handleToggle("logoEnabled")
        }}
      />
      <ListField
        iconFill="primary"
        props={{ mb: "16" }}
        label={t("time")}
        switch={{
          isChecked: fields.timeEnabled,
          onChange: () => handleToggle("timeEnabled")
        }}
      />
      <ListField
        iconFill="primary"
        props={{ mb: "16" }}
        label={t("customText")}
        switch={{
          isChecked: fields.customTextEnabled,
          onChange: () => handleToggle("customTextEnabled")
        }}
        childrenOutside
      >
        <Collapse in={fields.customTextEnabled} unmountOnExit>
          <Input
            maxLength={30}
            value={customText}
            onChange={(e: any) => setCustomText(e.target.value)}
            mt="20"
            mb="8"
            type="text"
          />
          <Text ml="16" mb="8" variant="label2">
            {t("plurals:num.charactersLeft", { count: 30 - customText.length })}
          </Text>
        </Collapse>
      </ListField>
      <Text mt="16" variant="body">
        {t("watermarkOverlay.description", { b: <strong /> })}
      </Text>
    </Box>
  );
}
